module.exports = function () {
	return {
		restrict: 'A',
		link(scope, element, $attrs) {
			scope.onExpanded = () => {
				angular.element('#' + $attrs.brandScrollTop).animate({
						scrollTop: element[0].offsetTop
				}, 300);
			};
		}
	};
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/advance-filter/filter-brand-scroll-top.js
 **/